export enum BookingDetailsDataHook {
  ACCORDION = 'booking-details-accordion',
}
